import { memo } from 'react'

interface HeadingProps {
  title: string
  subtitle?: React.ReactNode
}

const Heading: React.FC<HeadingProps> = memo(({ title, subtitle }) => {
  return (
    <>
      <h2 className="text-xl sm:text-[32px] mb-2 sm:mb-4 text-center font-seriftext max-w-[600px] mx-auto">
        {title}
      </h2>
      {subtitle && (
        <p className="text-center mb-4 sm:mb-8 text-white text-sm sm:text-lg max-w-[600px] mx-auto">
          {subtitle}
        </p>
      )}
    </>
  )
})

export { Heading }
